import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { finalize, Observable } from 'rxjs';
import { PcLoadingService } from 'app/shared/services/loading/loading.service';
import { PC_SKIP_LOADING } from 'app/shared/services/loading/loading.context';

@Injectable()
export class PcLoadingInterceptor implements HttpInterceptor {
  handleRequestsAutomatically: boolean;

  /**
   * Constructor
   */
  constructor(private _pcLoadingService: PcLoadingService) {
    // Subscribe to the auto
    this._pcLoadingService.auto$.subscribe((value) => {
      this.handleRequestsAutomatically = value;
    });
  }

  /**
   * Intercept
   *
   * @param req
   * @param next
   */
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // If the Auto mode is turned off, do nothing. Background requests opt out
    // the same way: nobody is waiting on them, so they must not cover the app
    // with the loading splash (see PC_SKIP_LOADING).
    if (!this.handleRequestsAutomatically || req.context.get(PC_SKIP_LOADING)) {
      return next.handle(req);
    }

    // Set the loading status to true
    this._pcLoadingService._setLoadingStatus(true, req.url);

    return next.handle(req).pipe(
      finalize(() => {
        // Set the status to false if there are any errors or the request is completed
        this._pcLoadingService._setLoadingStatus(false, req.url);
      })
    );
  }
}
